import React from 'react'
import { formatAmount, formatIntAmount } from '../../lib/formatAmountHandler'
import BilansSummaryStyle from '../../styles/BilansSummaryStyle'

class BilansSummary extends React.Component {
  pokazujRoznice(roznicaA, roznicaB, roznicaB1) {
    return roznicaA !== 0 || roznicaB !== 0 || roznicaB1 !== 0
  }

  dajWiersz(title, kwotaA, kwotaB, kwotaB1, hasError) {
    return (
      <div className="summary-row">
        <div className={hasError ? 'error title' : 'title'}>{title}</div>
        <div
          className={hasError ? 'error kwota' : 'kwota'}
          data-cy="kwotaA-summary"
        >
          {this.props.czyKwotyWTysiacach
            ? formatIntAmount(kwotaA)
            : formatAmount(kwotaA, 2)}
        </div>
        <div className={hasError ? 'error kwota' : 'kwota'}>
          {this.props.czyKwotyWTysiacach
            ? formatIntAmount(kwotaB)
            : formatAmount(kwotaB, 2)}
        </div>
        {this.props.isThirdColumn && (
          <div className={hasError ? 'error kwota b1' : 'kwota b1'}>
            {this.props.czyKwotyWTysiacach
              ? formatIntAmount(kwotaB1)
              : formatAmount(kwotaB1, 2)}
          </div>
        )}
      </div>
    )
  }
  render() {
    const {
      aktywaRazemA,
      aktywaRazemB,
      aktywaRazemB1,
      pasywaRazemA,
      pasywaRazemB,
      pasywaRazemB1,
      roznicaA,
      roznicaB,
      roznicaB1,
    } = this.props.dane
    return (
      <BilansSummaryStyle isThirdColumn={this.props.isThirdColumn}>
        <div className="summary">
          <div className="summaryName">PODSUMOWANIE</div>
          <div className="summaryData">
            {this.dajWiersz(
              'AKTYWA RAZEM:',
              aktywaRazemA,
              aktywaRazemB,
              aktywaRazemB1,
            )}
            {this.dajWiersz(
              'PASYWA RAZEM:',
              pasywaRazemA,
              pasywaRazemB,
              pasywaRazemB1,
            )}
            {this.pokazujRoznice(roznicaA, roznicaB, roznicaB1)
              ? this.dajWiersz('RÓŻNICA:', roznicaA, roznicaB, roznicaB1, true)
              : null}
          </div>
        </div>
      </BilansSummaryStyle>
    )
  }
}

export default BilansSummary
